/**
 * 商品分类Mock数据 - 李宁主题
 */

import { delay } from '@/utils/common';
import type { CategoryItem, CategoryListParams } from '@/api/modules/category';

// 模拟李宁产品分类数据
const mockCategories: CategoryItem[] = [
  // 一级分类
  {
    id: '1',
    categoryCode: 'LINING_SHOES',
    categoryName: '李宁运动鞋',
    level: 1,
    sort: 1,
    status: 'enabled',
    icon: 'icon-shoes',
    description: '李宁专业运动鞋系列',
    createTime: '2024-01-15 10:00:00',
    updateTime: '2024-01-15 10:00:00',
    children: [
      {
        id: '1-1',
        pid: '1',
        categoryCode: 'LINING_BASKETBALL',
        categoryName: '李宁篮球鞋',
        level: 2,
        sort: 1,
        status: 'enabled',
        description: '李宁专业篮球鞋，包括韦德之道、驭帅等系列',
        createTime: '2024-01-15 10:05:00',
        updateTime: '2024-01-15 10:05:00',
      },
      {
        id: '1-2',
        pid: '1',
        categoryCode: 'LINING_RUNNING',
        categoryName: '李宁跑步鞋',
        level: 2,
        sort: 2,
        status: 'enabled',
        description: '李宁专业跑步鞋，包括超轻、云四代等系列',
        createTime: '2024-01-15 10:06:00',
        updateTime: '2024-01-15 10:06:00',
      },
      {
        id: '1-3',
        pid: '1',
        categoryCode: 'LINING_BADMINTON',
        categoryName: '李宁羽毛球鞋',
        level: 2,
        sort: 3,
        status: 'enabled',
        description: '李宁专业羽毛球鞋，为羽毛球运动量身定制',
        createTime: '2024-01-15 10:07:00',
        updateTime: '2024-01-15 10:07:00',
      },
      {
        id: '1-4',
        pid: '1',
        categoryCode: 'LINING_TRAINING',
        categoryName: '李宁训练鞋',
        level: 2,
        sort: 4,
        status: 'enabled',
        description: '李宁多功能训练鞋，适合健身房和综合训练',
        createTime: '2024-01-15 10:08:00',
        updateTime: '2024-01-15 10:08:00',
      },
    ],
  },
  {
    id: '2',
    categoryCode: 'LINING_APPAREL',
    categoryName: '李宁运动服装',
    level: 1,
    sort: 2,
    status: 'enabled',
    icon: 'icon-clothes',
    description: '李宁专业运动服装系列',
    createTime: '2024-01-15 10:10:00',
    updateTime: '2024-01-15 10:10:00',
    children: [
      {
        id: '2-1',
        pid: '2',
        categoryCode: 'LINING_TSHIRTS',
        categoryName: '李宁T恤',
        level: 2,
        sort: 1,
        status: 'enabled',
        description: '李宁运动T恤，舒适透气',
        createTime: '2024-01-15 10:11:00',
        updateTime: '2024-01-15 10:11:00',
      },
      {
        id: '2-2',
        pid: '2',
        categoryCode: 'LINING_SHORTS',
        categoryName: '李宁短裤',
        level: 2,
        sort: 2,
        status: 'enabled',
        description: '李宁运动短裤，轻便快干',
        createTime: '2024-01-15 10:12:00',
        updateTime: '2024-01-15 10:12:00',
      },
      {
        id: '2-3',
        pid: '2',
        categoryCode: 'LINING_JACKETS',
        categoryName: '李宁外套',
        level: 2,
        sort: 3,
        status: 'enabled',
        description: '李宁运动外套，防风保暖',
        createTime: '2024-01-15 10:13:00',
        updateTime: '2024-01-15 10:13:00',
      },
      {
        id: '2-4',
        pid: '2',
        categoryCode: 'LINING_PANTS',
        categoryName: '李宁运动长裤',
        level: 2,
        sort: 4,
        status: 'enabled',
        description: '李宁运动长裤，舒适修身',
        createTime: '2024-01-15 10:14:00',
        updateTime: '2024-01-15 10:14:00',
      },
    ],
  },
  {
    id: '3',
    categoryCode: 'LINING_ACCESSORIES',
    categoryName: '李宁运动配件',
    level: 1,
    sort: 3,
    status: 'enabled',
    icon: 'icon-accessories',
    description: '李宁运动配件系列',
    createTime: '2024-01-15 10:15:00',
    updateTime: '2024-01-15 10:15:00',
    children: [
      {
        id: '3-1',
        pid: '3',
        categoryCode: 'LINING_BAGS',
        categoryName: '李宁运动包',
        level: 2,
        sort: 1,
        status: 'enabled',
        description: '李宁运动背包、手提包等',
        createTime: '2024-01-15 10:16:00',
        updateTime: '2024-01-15 10:16:00',
      },
      {
        id: '3-2',
        pid: '3',
        categoryCode: 'LINING_CAPS',
        categoryName: '李宁帽子',
        level: 2,
        sort: 2,
        status: 'enabled',
        description: '李宁运动帽子，防晒透气',
        createTime: '2024-01-15 10:17:00',
        updateTime: '2024-01-15 10:17:00',
      },
      {
        id: '3-3',
        pid: '3',
        categoryCode: 'LINING_SOCKS',
        categoryName: '李宁袜子',
        level: 2,
        sort: 3,
        status: 'enabled',
        description: '李宁运动袜子，吸汗透气',
        createTime: '2024-01-15 10:18:00',
        updateTime: '2024-01-15 10:18:00',
      },
    ],
  },
  {
    id: '4',
    categoryCode: 'BADMINTON_EQUIPMENT',
    categoryName: '李宁羽毛球装备',
    level: 1,
    sort: 4,
    status: 'enabled',
    icon: 'icon-badminton',
    description: '李宁羽毛球专业装备',
    createTime: '2024-01-15 10:20:00',
    updateTime: '2024-01-15 10:20:00',
    children: [
      {
        id: '4-1',
        pid: '4',
        categoryCode: 'BADMINTON_RACKETS',
        categoryName: '李宁羽毛球拍',
        level: 2,
        sort: 1,
        status: 'enabled',
        description: '李宁专业羽毛球拍，包括风动、风暴等系列',
        createTime: '2024-01-15 10:21:00',
        updateTime: '2024-01-15 10:21:00',
      },
      {
        id: '4-2',
        pid: '4',
        categoryCode: 'SHUTTLECOCKS',
        categoryName: '李宁羽毛球',
        level: 2,
        sort: 2,
        status: 'enabled',
        description: '李宁羽毛球，比赛级品质',
        createTime: '2024-01-15 10:22:00',
        updateTime: '2024-01-15 10:22:00',
      },
      {
        id: '4-3',
        pid: '4',
        categoryCode: 'BADMINTON_STRINGS',
        categoryName: '李宁羽毛球线',
        level: 2,
        sort: 3,
        status: 'enabled',
        description: '李宁专业羽毛球线，高弹性耐用',
        createTime: '2024-01-15 10:23:00',
        updateTime: '2024-01-15 10:23:00',
      },
    ],
  },
  {
    id: '5',
    categoryCode: 'LIFESTYLE',
    categoryName: '李宁生活方式',
    level: 1,
    sort: 5,
    status: 'enabled',
    icon: 'icon-lifestyle',
    description: '李宁生活方式产品系列',
    createTime: '2024-01-15 10:25:00',
    updateTime: '2024-01-15 10:25:00',
    children: [
      {
        id: '5-1',
        pid: '5',
        categoryCode: 'LIFESTYLE_SHOES',
        categoryName: '李宁休闲鞋',
        level: 2,
        sort: 1,
        status: 'enabled',
        description: '李宁时尚休闲鞋，日常穿搭',
        createTime: '2024-01-15 10:26:00',
        updateTime: '2024-01-15 10:26:00',
      },
      {
        id: '5-2',
        pid: '5',
        categoryCode: 'LIFESTYLE_APPAREL',
        categoryName: '李宁休闲服装',
        level: 2,
        sort: 2,
        status: 'enabled',
        description: '李宁时尚休闲服装，舒适百搭',
        createTime: '2024-01-15 10:27:00',
        updateTime: '2024-01-15 10:27:00',
      },
    ],
  },
];

// 扁平化的分类数据（用于列表显示）
const flatCategories: CategoryItem[] = [];

function flattenCategories(categories: CategoryItem[], result: CategoryItem[] = []) {
  categories.forEach(category => {
    result.push(category);
    if (category.children) {
      flattenCategories(category.children, result);
    }
  });
  return result;
}

flattenCategories(mockCategories, flatCategories);

// Mock API函数
export const categoryMockApi = {
  // 获取分类树形结构
  getCategoryTree: async (): Promise<{ data: CategoryItem[] }> => {
    await delay(500);
    return { data: mockCategories };
  },

  // 获取分类列表（分页）
  getCategoryList: async (params: CategoryListParams = {}): Promise<{
    data: CategoryItem[];
    total: number;
  }> => {
    await delay(300);
    
    let filteredData = [...flatCategories];
    
    // 筛选条件
    if (params.categoryName) {
      filteredData = filteredData.filter(item =>
        item.categoryName.includes(params.categoryName!)
      );
    }
    
    if (params.status) {
      filteredData = filteredData.filter(item => item.status === params.status);
    }
    
    if (params.level) {
      filteredData = filteredData.filter(item => item.level === params.level);
    }
    
    // 分页
    const page = params.page || 1;
    const perPage = params.per_page || 10;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    
    return {
      data: filteredData.slice(start, end),
      total: filteredData.length,
    };
  },

  // 获取分类详情
  getCategoryById: async (id: string): Promise<{ data: CategoryItem }> => {
    await delay(200);
    const category = flatCategories.find(item => item.id === id);
    if (!category) {
      throw new Error('分类不存在');
    }
    return { data: category };
  },

  // 创建分类
  createCategory: async (data: any): Promise<{ data: CategoryItem }> => {
    await delay(800);
    const newCategory: CategoryItem = {
      id: Date.now().toString(),
      ...data,
      level: data.pid ? 2 : 1,
      createTime: new Date().toLocaleString(),
      updateTime: new Date().toLocaleString(),
    };
    flatCategories.push(newCategory);
    return { data: newCategory };
  },

  // 更新分类
  updateCategory: async (id: string, data: any): Promise<{ data: CategoryItem }> => {
    await delay(600);
    const index = flatCategories.findIndex(item => item.id === id);
    if (index === -1) {
      throw new Error('分类不存在');
    }
    const updatedCategory = {
      ...flatCategories[index],
      ...data,
      updateTime: new Date().toLocaleString(),
    };
    flatCategories[index] = updatedCategory;
    return { data: updatedCategory };
  },

  // 删除分类
  deleteCategory: async (id: string): Promise<{ success: boolean }> => {
    await delay(500);
    const index = flatCategories.findIndex(item => item.id === id);
    if (index === -1) {
      throw new Error('分类不存在');
    }
    flatCategories.splice(index, 1);
    return { success: true };
  },

  // 批量删除分类
  batchDeleteCategories: async (ids: string[]): Promise<{ success: boolean }> => {
    await delay(800);
    ids.forEach(id => {
      const index = flatCategories.findIndex(item => item.id === id);
      if (index !== -1) {
        flatCategories.splice(index, 1);
      }
    });
    return { success: true };
  },

  // 更新分类状态
  updateCategoryStatus: async (id: string, status: 'enabled' | 'disabled'): Promise<{ success: boolean }> => {
    await delay(400);
    const category = flatCategories.find(item => item.id === id);
    if (!category) {
      throw new Error('分类不存在');
    }
    category.status = status;
    category.updateTime = new Date().toLocaleString();
    return { success: true };
  },

  // 获取分类选项
  getCategoryOptions: async (): Promise<{ data: Array<{ label: string; value: string; level: number }> }> => {
    await delay(200);
    const options = flatCategories
      .filter(item => item.status === 'enabled')
      .map(item => ({
        label: item.categoryName,
        value: item.id,
        level: item.level,
      }));
    return { data: options };
  },
};

// 导出兼容的 categoryMockData 对象，用于 mockApi.ts
export const categoryMockData = {
  getCategoryOptions: async () => {
    const result = await categoryMockApi.getCategoryOptions();
    return result.data;
  },

  getCategoryTree: async () => {
    const result = await categoryMockApi.getCategoryTree();
    return result.data;
  },

  getCategoryList: async (params: CategoryListParams = {}) => {
    const result = await categoryMockApi.getCategoryList(params);
    return {
      list: result.data,
      total: result.total,
      page: params.page || 1,
      per_page: params.per_page || 10,
    };
  },

  getCategoryDetail: async (id: string) => {
    const result = await categoryMockApi.getCategoryById(id);
    return result.data;
  },

  createCategory: async (data: any) => {
    const result = await categoryMockApi.createCategory(data);
    return result.data;
  },

  updateCategory: async (id: string, data: any) => {
    const result = await categoryMockApi.updateCategory(id, data);
    return result.data;
  },

  deleteCategory: async (id: string) => {
    const result = await categoryMockApi.deleteCategory(id);
    return result.success;
  },
};

// 默认导出
export default categoryMockApi;